import { Typography } from "@shared/ui.primitives";
import { GenericMarkdown } from "components/Shop/PDPPage/GenericMarkdown";

export const Highlights = ({ text }: { text: string }) => {
  return (
    <div>
      <Typography as="h3" variant="subheader-3" colour="primary-dark">
        Highlights
      </Typography>
      <div>
        <GenericMarkdown usePearlStyles content={text} />
      </div>
    </div>
  );
};
